export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref10543.0cf0ac1d.jpg";